/**
 * Whether this browser has a home to go back to.
 *
 * `/home` only means something to a phone-verified session — that is exactly
 * the set of people with work listed there. An anonymous visitor who opened a
 * shared link has no home, and offering them one mid-task would send them to a
 * signup screen they did not ask for.
 */
import { useEffect, useState } from 'react';
import { hasVerifiedPhoneOnSession } from '../services/auth';

/** The home is the site root. `/home` still resolves, for links already shared. */
export const HOME_PATH = '/';

/**
 * @param recheckKey change this when the session may have been upgraded in
 * place — verifying a phone mid-flow gives the user a home they did not have
 * when the surface first mounted.
 */
export function useHasHome(recheckKey?: unknown): boolean {
  const [hasHome, setHasHome] = useState(false);

  useEffect(() => {
    let cancelled = false;
    hasVerifiedPhoneOnSession()
      .then((verified) => {
        if (!cancelled) setHasHome(verified);
      })
      .catch(() => {
        // No home is the safe answer: the surface simply omits the button.
      });
    return () => {
      cancelled = true;
    };
  }, [recheckKey]);

  return hasHome;
}

export default useHasHome;
